import {createEntityAdapter} from '@reduxjs/toolkit'
import {IBillType} from '../../types'

export const billTypesAdapter = createEntityAdapter<IBillType>()